export const HEADER_MOBILE_EVENTS = {
  HEADER_MOBILE_MENU_TOGGLE: 'header-mobile-menu-toggle',
};
